import React from 'react';
import { motion } from 'framer-motion';

/* Animación de aparición suave al hacer scroll (se ejecuta una sola vez por elemento) */
export const Reveal = ({ children, delay = 0, y = 26, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-50px' }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
